import React from 'react'
import {Time} from 'yougile-util'
import {Sync} from '@client/sync'
import {ChatSystemMessage} from '@components/common/base/chat-system-message'
import {SystemMessageProps} from '@components/right-panel/chat/chat-messages/message/types'
import {MessageUtils} from '@extensions/message-utils'

export const DeadlineSystemMessage = ({
  message,
  className,
  animateShow
}: SystemMessageProps) => {
  const box = Sync.getOrCurrent(message)
  const html = MessageUtils.renderHtmlForView(box, message)
  return (
    <ChatSystemMessage
      type="error"
      icon="IconCalendarEvent"
      html={html}
      dateTime={Time.formatDateTime(message.timestamp, false, false, true)}
      className={className}
      animateShow={animateShow}
      timestamp={message.timestamp}
    />
  )
}
